class TimeoutWarningModalController {

    constructor(
        $timeout,
        TimeoutWarningService
    ) {
        'ngInject';

        this.$timeout = $timeout;
        this.TimeoutWarningService = TimeoutWarningService;
    }

    $onInit() {
        this.maxCountdown = this.resolve.maxCountdown;
        this.currentCountdownTick = this.maxCountdown;
        this.isOutOfTime = false;

        this.startCountdown();
    }

    /***
     *  Begin counting down every second. If we hit 0 seconds or the modal is closed, stop the interval and display
     *  the "out of time" message.
     */
    startCountdown() {
        this.countdownInterval = setInterval(() => {
            this.$timeout(() => {
                this.currentCountdownTick--;
            });
            if (this.currentCountdownTick <= 0 || !this.TimeoutWarningService.isModalOpen) {
                clearInterval(this.countdownInterval);
                this.isOutOfTime = true;
            }
        }, 1000)
    }

}

export default TimeoutWarningModalController;


// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-modal/timeout-warning-modal-controller.js